export function isMandatory(mandatoryFields: string[], field: string): boolean {
    return mandatoryFields.indexOf(field) > -1;
}
